import styled from 'styled-components';

import { Button } from '@speeki/global-ui-components';

export const CasePinFormWrapper = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
`;

export const ContinueButton = styled(Button)`
    margin: 32px 0 0;
    min-width: auto;
`;
